import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IOrganization } from '../common/types/organisation';

const initialState: IOrganization[] = [];

export const organisationSlice = createSlice({
  name: 'organisation',
  initialState,
  reducers: {
    setOrganisations: (_state, action: PayloadAction<IOrganization[]>) => {
      return action.payload;
    },
    addOrganisation: (state, action: PayloadAction<IOrganization>) => {
      state.push(action.payload);
    },
    updateOrganisation: (state, action: PayloadAction<IOrganization>) => {
      const index = state.findIndex((org) => org.id === action.payload.id);
      if (index !== -1) {
        state[index] = action.payload;
      }
    },
    deleteOrganisation: (state, action: PayloadAction<string>) => {
      return state.filter((org) => org.id !== action.payload);
    },
  },
});

export const { setOrganisations, addOrganisation, updateOrganisation, deleteOrganisation } =
  organisationSlice.actions;
export default organisationSlice.reducer;
